import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../function/config";
import axios from "axios";
import HomeNav from "./Navbars/HomeNav";
import Footer from "./Footer";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { toast } from "react-toastify";

export default function SingleShipCharterReg() {
  const [obj, setObj] = useState({});

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenS, setIsOpenS] = useState(true);

  const { id } = useParams();

  const [isScrolled, setIsScrolled] = useState(false);

  useLayoutEffect(() => {
  window.scrollTo(0, 0);
}, [id]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleshipReg/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setObj(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);


  const [thumbnailImage, setThumbnailImage] = useState("");
  const [mainImages, setMainImages] = useState([]); // Store multiple images

  useEffect(() => {
    async function fetchShipImages() {
      try {
        const response = await axios.get(`${config.base_url}/api/HappyMarineShipping/singleShipImageReg/${id}`);

        if (response.data.status === 200 && response.data.data.length > 0) {
          console.log("Fetched Images Data:", response.data.data);

          // Extract thumbnail image
          const thumbnailImageData = response.data.data.find(img => img.thumbnail_image !== null);
          setThumbnailImage(thumbnailImageData ? thumbnailImageData.thumbnail_image : "");

          // Extract all main images
          const mainImagesData = response.data.data.filter(img => img.image !== null).map(img => img.image);
          setMainImages(mainImagesData);

          console.log("Thumbnail Image URL:", thumbnailImageData ? thumbnailImageData.thumbnail_image : "No Thumbnail Found");
          console.log("Main Images Array:", mainImagesData);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }

    fetchShipImages();
  }, [id]);

  const [isOpenModal, setIsOpenModal] = useState(false);        // for dropdown
const [showModal, setShowModal] = useState(false);  // for enquiry modal
const [Name,setName] = useState('')
const [Email,setEmail] = useState('')
const [Mobile,setMobile] = useState('')
const [Subject,setSubject] = useState('')
const [loading,setLoading] =useState(false)
const [count,setCount] = useState(1)

  const EnquirySubmit = async(e)=>{
    e.preventDefault();
    setLoading(true)
    const formData = new FormData();
      formData.append("name", Name);
      formData.append("email", Email);
      formData.append("mobile", Mobile);
      formData.append("subject", Subject);
          
    try {
                  
                    const response = await axios.post(`${config.base_url}/api/HappyMarineShipping/add_enquiry`,formData,{
                      headers:{
                        'Content-Type':'multipart/form-data',
                      }
                    });
                    if(response.data.status===200){
                     
                      console.log(response)
                      setLoading(false)
                      setShowModal(false)
                      toast.success("Sent Successfully!",{
                        autoClose:1500,
                        position:'top-right',
                        
                      });
                      setCount(id)
                     
                     
                      
                    }
                    else{
                        setLoading(false)
                      console.log("error1")
                      toast.error("Fill the required Fields",{
                        autoClose:1500,
                        position: "top-right",
                      })
                    }
                    
                  } catch (err) {
                    setLoading(false)
                    console.log("error2",err)
                    toast.error("Error",{
                      autoClose:2000,
                      position: "top-right",
                    })
                  }

  }


  const [allShips, setallShips] = useState([]);
    const [allShipsReg, setallShipsReg] = useState([]);
  
   
    // Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res1.data.status === 200) {
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShips(sortedData); 
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  
  
  // Fetch Customer Registered Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res1.data.status === 200) {
          // Sort using created_at (not date_added)
          const sortedData = res1.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); 
          setallShipsReg(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  
  
    
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
  
  const [allImages,setallImages] = useState([])
   
    
    useEffect(() => {
      async function fetchdata() {
        try {
          const res3 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/ship_images`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }
            }
          );
          if (res3.data.status === 200) {
            console.log("Images :",res3);
            setallImages(res3.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url,count]);

    const [allImagesReg,setAllImagesReg] = useState([])
        
          useEffect(() => {
            async function fetchdata() {
              try {
                const res3 = await axios.get(
                  `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    }
                  }
                );
                if (res3.data.status === 200) {
                  console.log("Images :",res3);
                  setAllImagesReg(res3.data.data);
                } else {
                  console.log("error");
                }
              } catch (error) {
                console.log(error);
              }
            }
            fetchdata();
          }, [config.base_url,count]);
  
    // Add an identifier to distinguish Admin Ships and Customer Ships
  const filteredAllShipsReg = allShipsReg
  .filter((ship) => ship.is_allow)
  .map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale
  
  const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship
  
  // Merge and sort ships by created_at (latest first)
  const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const similarShips = shuffleArray(
  sortedData.filter(
    (ship) => ship.vessel_type === obj.vessel_type && ship.id !== obj.id
  )
);


  
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Add this above your return block or inside the component
  const handleCloseModal = () => setSelectedImage(null);
  


  return (
    <div className="bg-gradient-to-r from-[#2e5775] to-[#326e99]">
      <HomeNav />
      <div className="px-10 lg:hidden mt-5">
      <button className="text-white" onClick={() => navigate(`/ship-chartering`)}>
      <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
      </button>
        </div>
      <div className="hidden lg:block p-5 px-10  bg-white">
        <div className="flex justify-between flex-wrap gap-3">
          <h1 className="text-[#d1a460] text-xl font-bold">Ship Details</h1>
          <div>
            <Link to={"/"} className="text-xl text-[#d1a460]">
              Home /{" "}
            </Link>
            <Link to={"/"} className="text-xl text-[#d1a460]">
              {" "}
              Categories /
            </Link>
          </div>
        </div>
      </div>

      <div className="px-10 xm:px-2 lg:block hidden mt-5">
      <button className="text-white" onClick={() => navigate(`/ship-chartering`)}>
      <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
      </button>
        </div>

      <div className="flex gap-5  2xl:block  xm:p-3 mt-[20px] mb-10 px-10">
       

        {/* 2nd div description */}
        <div className="w-[70%] 2xl:w-[100%] h-full 2xl:mt-5 border rounded  border-gray-400 bg-[#123d5f] flex flex-col ">
          <div className=" rounded-t ">
            <div className="text-gray-200">
              <div className="px-3 py-3">
                <div
                  className="flex justify-between items-center xm:text-lg xm:px-2 rounded bg-[#d1a460] py-3 text-white font-bold text-xl px-4 cursor-pointer"
                  
                >
                  
                  <h1>Short Descriptions</h1>
                  <h1 className=""> Ref : {obj.ship_code} - {id}</h1>
                 
                    
                </div>
              </div>

              
                <div className="flex justify-between md:flex-wrap-reverse px-3 w-[100%]"> 

                  <div className="px-3 py-3 w-[90%]">
                    {/* Short Description */}
                    {obj.short_description && (
                      <div className="flex gap-3 border-b border-gray-300 py-1">
                       <span className="text-[#d1a460]   font-bold px-1  ">
                                {obj.short_description}
                              </span>
                      </div>
                    )}
  
                    {/* Flag and Capacity */}
                   
                    {/* LOA and Built Year */}
                    {(obj.Flag || obj.year_built) && (
                      <div className="  mt-3">
                        {obj.year_built && (
                          <div className="w-full">
                            <span className="font-semibold  ">
                              Year Built:
                            </span>
                            <span className="text-[#d1a460] ml-[27px]">
                              {obj.year_built}
                            </span>
                          </div>
                        )}
                         {(obj.LOA || obj.capacity) && (
                      <div className=" ">
                        {obj.LOA && (
                          <div className="w-full">
                            <span className="font-semibold  ">
                            LOA:
                            </span>
                            <span className="text-[#d1a460] ml-[72px]">
                              {obj.LOA}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
  
                         {obj.Flag && (
                          <div className="w-full">
                            <span className="font-semibold  ">
                              Flag:
                            </span>
                            <span className="text-[#d1a460] ml-[70px]">{obj.flag}</span>
                          </div>
                        )}
                      </div>
                    )}
  
                    {/* Class and GRT/NRT */}
                    
                      <div className=" ">
                       
                      {obj.Class &&(
                          <div className="w-full">
                          <span className="font-semibold ">
                          Class:
                          </span>
                          <span className="text-[#d1a460]  ml-[60px]">
                          {
                              obj.Class
                          }
                          </span>
                      </div>
                      )
                          }
                       
                        
                          {obj.GRT_NRT &&(
                              <div className="w-full">
                              <span className="font-semibold ">
                                GRT/NRT:
                              </span>
                              <span className="text-[#d1a460] ml-[34px]">
                                {
                                  obj.GRT_NRT
                                }
                              </span>
                            </div>
                          )
                              }
                       
                      </div>
                    
  
                    {/* Main Engine and DWT */}
                    
                      <div className=" ">
                        <div className=" ">
                        
                          {obj.Teu && (
                              <div className="w-full">
                            <span className="font-semibold ">
                              Teu:
                            </span>
                            <span className="text-[#d1a460] ml-[77px]">
                              {
                                obj.Teu
                              }
                            </span>
                          </div>)}
                      </div>
  
                        
                          {obj.DWT &&(<div className="w-full">
                            <span className="font-semibold ">
                              DWT:
                            </span>
                            <span className="text-[#d1a460] ml-[70px]">
                              {
                                obj.DWT
                              }
                            </span>
                          </div>)}
  
                           <div className=" ">
                        
                          {obj.Price && (
                              <div className="w-full">
                            <span className="font-semibold ">
                              Price:
                            </span>
                            <span className="text-[#d1a460] ml-[68px]">
                              {
                                obj.Price
                              }
                            </span>
                          </div>)}
                        
                      </div>
  
                           {obj.main_engine && (
                              <div className="w-full">
                            <span className="font-semibold ">
                              Main Engine:
                            </span>
                            <span className="text-[#d1a460] ml-2">
                              {
                                obj.main_engine
                              }
                            </span>
                          </div>)}
                        
                      </div>
  
                      
                     
  
                      
  
                    {/* <div className="w-full mt-5">
                      <span
                        onClick={() => navigate(`/shipLoc/${obj.id}`)}
                        className=" text-blue-400 cursor-pointer hover:underline "
                      >
                        Track Location
                      </span>
                    </div> */}
                  </div>

                   <div className="w-[500px]  md:m-auto xm:w-full bg-[#123d5f] border p-2 border-gray-400">
  <div className="w-full h-full relative cursor-pointer">
    {mainImages.length > 0 ? (
      <>
        <img
          src={mainImages[0]}
          className="w-full xm:w-full h-full"
          alt="Ship Image"
          onClick={() => setSelectedImage(mainImages[0])}
        />
        {/* Hover Overlay */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300"
        >
          <span className="text-white text-sm font-semibold underline">
            Click here to view image
          </span>
        </div>

        {/* Enlarge Icon */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute bottom-2 right-2 bg-black bg-opacity-60 px-3 py-2 rounded-full hover:bg-opacity-90 transition"
          title="Click to enlarge"
        >
          <i class="fa-solid fa-up-right-and-down-left-from-center  text-white"></i>
        </div>
      </>
    ) : !thumbnailImage ? (
      <img
        src="fallback.jpg"
        className="w-full h-full"
        alt="No Image Available"
      />
    ) : null}
  </div>
</div>
                </div>
              
               
            </div>
          </div>
            {selectedImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
    onClick={handleCloseModal}
  >
    <div
      className="w-[1000px] h-[600px] xm:w-[500px] xm:h-[300px] overflow-auto"
      onClick={(e) => e.stopPropagation()}
    >
      
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        initialSlide={mainImages.findIndex((img) => img === selectedImage)}
        className="w-full h-full"
      >
        
        {mainImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div
          onClick={handleCloseModal}
          className="absolute top-2 right-2 cursor-pointer bg-opacity-60 px-4 py-2 rounded-full hover:bg-opacity-90 transition"
        >
          <h1 className="text-red-600 font-bold text-2xl ">X</h1>
        </div>
            <img
              src={image}
              onClick={handleCloseModal}
              alt={`Enlarged ${index}`}
              className="rounded-lg w-full h-full m-auto"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
)}
          <div className=" px-3 mt-4 py-3">
           <div className="border rounded border-gray-400">
  {/* Dropdown Header */}
  <div
    className="flex justify-between rounded items-center bg-[#d1a460] py-3 text-white font-bold text-xl px-4 cursor-pointer"
    
  >
    <h1>More Informations</h1>
    
  </div>

  {/* Dropdown Content */}
  
    <div className="relative p-3 text-base text-[#d1a460]">
      <div className="pr-32">
        {obj.brief_description ? (
          obj.brief_description.split("\n").map((detail, index) => {
            // Simple regex to detect URLs
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            const parts = detail.split(urlRegex);

            return (
              <p key={index} className="mb-2 break-words whitespace-pre-wrap">
  {parts.map((part, i) =>
    urlRegex.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline hover:text-blue-800 break-words"
      >
        {part}
      </a>
    ) : (
      <span key={i}>{part}</span>
    )
  )}
</p>

            );
          })
        ) : (
          <p className="text-red-500">No description available</p>
        )}
      </div>

      {/* Enquiry Now Button */}
      <button
                onClick={() => setShowModal(true)}
                className="absolute bottom-3 right-3 text-black bg-gray-50 border border-[#a1ccec] hover:bg-green-500 hover:text-white rounded-md px-3 py-2 shadow-lg hover:shadow-xl transition"
              >
                Send Enquiry
              </button>
    </div>
  
</div>

          </div>
          {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 xm:px-3 flex justify-center items-center z-50">
          <div className="bg-white w-[650px] xm:w-auto xl:max-w-md rounded-lg shadow-lg relative">
      <div className="bg-[#123d5f] px-6 py-3 flex justify-between"> <h2 className="text-2xl font-bold   text-white">Enquiry Form</h2> 
      <button onClick={()=>setShowModal(false)} className="text-2xl font-bold   text-red-500">X</button>
      </div>      
      <form className="space-y-4 p-6">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Your Name/Company Name
          </label>
          <input
            id="name"
            type="text"
            placeholder="Name"
            value={Name}
            onChange={(e)=>setName(e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-2"
          />
        </div>
      
        <div className="flex gap-4 xl:flex-wrap xl:gap-0 items-center">
          <div className="w-full">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={Email}
              onChange={(e)=>setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
          </div>
          <div className="w-full">
            <label htmlFor="mobile" className="block text-sm font-medium text-gray-700">
              Mobile
            </label>
            <input
              id="mobile"
              type="tel"
              placeholder="Mobile"
              value={Mobile}
              onChange={(e)=>setMobile(e.target.value)}
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
          </div>
        </div>
      
        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
            Subject
          </label>
          <textarea
            id="subject"
            placeholder="Subject"
            value={Subject}
            onChange={(e)=>setSubject(e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-2"
          />
        </div>
      
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={(e)=>EnquirySubmit(e)}
            className="bg-[#123d5f] text-white px-4 py-2 rounded hover:bg-[#0f2e48]"
          >
           {loading ? (
                          <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                        ) : (
                          "Submit"
                        )}
          </button>
        </div>
      </form>
      
          </div>
        </div>
      )}
        </div>

       {/*3rd similar ships */}
        <div className="w-[25%] 2xl:w-[100%] 2xl:mt-5 h-full overflow-y-auto border bg-[#123d5f] border-gray-400 rounded  p-2">
  <h2 className="text-white text-lg font-semibold mb-2">Similar Ships</h2>
  {similarShips.length > 0 ? (
    similarShips.slice(0, 3).map((ship) => (
      <div key={ship.id} className="bg-white mb-3 p-2 rounded shadow">
        <p className="font-bold text-gray-800">{ship.short_description}</p>
        <p className="text-sm text-gray-600">Type: {ship.vessel_type}</p>
        <p className="text-sm text-gray-600">Flag: {ship.flag}</p>
        {/* Optionally show thumbnail */}
       <div>
  {(() => {
    let imageUrl = null;

    const images = ship.isFromReg
      ? allImagesReg.filter((img) => img.ships === ship.id)
      : allImages.filter((img) => img.ship === ship.id);

    imageUrl = images[0]?.image;

    if (!imageUrl) return null;

    const route = ship.isFromReg
      ? `/singleShipReg/${ship.id}`
      : `/singleShiphome/${ship.id}`;

    return (
      <img
       onClick={() => {
  navigate(route);
  window.location.reload(); // Refresh after navigation
}}
        src={imageUrl}
        className="w-full h-[150px] cursor-pointer mt-1 rounded"
        alt="Ship"
      />
    );
  })()}
</div>

      </div>
    ))
  ) : (
    <p className="text-gray-200">No similar ships found</p>
  )}
</div>
      </div>

      <Footer />
    </div>
  );
}